export default __webpack_public_path__ + "static/media/dance-marathon.e68d43d4.png";